var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-navigation-drawer',{staticClass:"navigation-drawer-left fill-height",attrs:{"app":"","floating":"","value":_vm.show}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }